export const SELECT_AND_LINK_PARAM = 'select_and_link'

export const SELECT_AND_LINK_POST_MESSAGE_TYPE = 'select_and_link'

export const CANCEL_SELECT_AND_LINK_POST_MESSAGE_TYPE = 'cancel_select_and_link'

export const SELECT_AND_LINK_SESSION_STORAGE_KEY = 'selectAndLinkSession'

export enum targetComponents {
  FILTER_FIELDS = 'FilterFields',
  OBJECT_VIEW = 'ObjectView'
}
